import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, catchError } from 'rxjs';
import { environment } from 'src/app/environments/environment';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class WebhookService {
    constructor(public http: HttpClient, private router: Router) {}
    headers = new HttpHeaders().set('Content-Type', 'application/json');

    base_url = environment.apiUrl;

    createWebhook( data: any): Observable<any> {
        // console.log(data)
        return this.http
        .post(this.base_url + `webhook-config/`, data, {
            headers: this.headers,
        })
        .pipe(
            catchError((error:any) => {
                return throwError(error);
            })
        );
    }

    getWebhooks(): Observable<any> {
        return this.http
        .get(this.base_url + 'webhook-config')
        .pipe(
          catchError((error: any) => {
            return throwError(error)
          })
        );
      }

     updateWebhook( data: any): Observable<any> {
        return this.http
        .patch(this.base_url + 'webhook-config', data)
        .pipe(
          catchError((error: any) => {
            return throwError(error);
          })
        );
      }

}